// src/apiClient.js
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";

export const API_BASE_URL = window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Non-hook helper for plain calls when you don't want React hook context.
export function createAuthorizedHeaders(token) {
  const headers = {
    "Accept": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

// Custom hook for components: gives you authorized fetch
export function useApiClient() {
  const { token, logout } = useAuth();
  const navigate = useNavigate();

  const authorizedFetch = async (path, options = {}) => {
    const url = `${API_BASE_URL}${path}`;
    const headers = createAuthorizedHeaders(token);

    // Don't override headers if user explicitly sends FormData, etc.
    const finalOptions = {
      ...options,
      headers: {
        ...headers,
        ...(options.headers || {}),
      },
    };

    const res = await fetch(url, finalOptions);

    if (res.status === 401) {
      logout();
      navigate("/login", { replace: true });
      throw new Error("Session expired. Please log in again.");
    }

    const contentType = res.headers.get("Content-Type") || "";
    const isJson = contentType.includes("application/json");

    if (!res.ok) {
      const errBody = isJson ? await res.json().catch(() => null) : null;
      const message =
        errBody?.message || `Request failed with status ${res.status}`;
      throw new Error(message);
    }

    return isJson ? res.json() : res.text();
  };

  return { authorizedFetch };
}